import React, { Component } from 'react';
import Breadcrumb from "../common/breadcrumb";
import ContactUs from '../../assets/images/contact.png'
import ComingSoon from '../../assets/images/coming-soon1.jpg'

class Coming extends Component {

    constructor(props) {
        super(props)
    }

    render() {


        return (
            <div>
                {/* <Breadcrumb title={'تماس با ما'}/> */}


                {/*Forget Password section*/}
                <section className=" contact-page section-b-space">
                    <div className="container ">
                        <div className="row section-b-space">
                            <div className="col-lg-12 map text-center" > 
                            <div className='img-box'>
                                
                            <img src={ComingSoon} />
                                </div> 
                                <div>
                                    <div className='mt-4'>
                                        <h3 className='text-center'>این بخش به زودی راه اندازی می شود.</h3>
                                     
                                    </div>
                                </div>
                              
                            </div>
                            {/* <div className="col-lg-6">
                                <div className="contact-right">
                                    <ul>
                                        <li>
                                            <div className="contact-icon">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon/phone.png`} alt="Generic placeholder image" />
                                                    <h6>تماس</h6>
                                            </div>
                                            <div className="media-body">
                                                <p>021-22322619</p>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="contact-icon">
                                                <img src={`${process.env.PUBLIC_URL}/assets/images/icon/email.png`} alt="Generic placeholder image" />
                                                    <h6>ایمیل</h6>
                                            </div>
                                            <div className="media-body">
                                                <p>ezcard724@gmail.com</p>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div> */}
                        </div>


                        {/* <div className="row">
                            <div className="col-sm-12">
                                <form className="theme-form">
                                    <div className="form-row">
                                        <div className="col-md-6">
                                            <label htmlFor="name">نام</label>
                                            <input type="text" className="form-control" id="name"
                                                   placeholder="نام خود را وارد کنید" required="" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="email">نام خانوادگی</label>
                                            <input type="text" className="form-control" id="last-name"
                                                   placeholder="نام خانوادگی خود را وارد کنید" required="" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="review">شماره تماس</label>
                                            <input type="text" className="form-control" id="review"
                                                   placeholder="شماره تماس خود را وارد کنید" required="" />
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="email">ایمیل</label>
                                            <input type="text" className="form-control" id="email" placeholder="ایمیل خود را وارد کنید"
                                                   required="" />
                                        </div>
                                        <div className="col-md-12">
                                            <label htmlFor="review">پیام</label>
                                            <textarea className="form-control" placeholder="پیام خود را وارد کنید"
                                                      id="exampleFormControlTextarea1" rows="6"></textarea>
                                        </div>
                                        <div className="col-md-12">
                                            <button className="btn btn-solid" type="submit">ارسال پیام</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> */}
                    </div>
                </section>

            </div>
        )
    }
}

export default Coming